import React from 'react';
import { Box } from '@mui/material';
import MaintenanceDetailsPage from '../../components/maintenance/MaintenanceDetailsPage';

const MantenimientoDetallePage = () => {  

  return (
    <Box sx={{ p: 2 }}>
      <MaintenanceDetailsPage
        onReorder={(newOrder) => {
          console.log('Nuevo orden de detalle de mantenimiento:', newOrder);
        }}
      />
    </Box>
  );
};

export default MantenimientoDetallePage;